var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(i,index){return _c('div',{key:index,staticClass:"rever-display-item"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(i.label))]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(i.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }